module.exports = __webpack_public_path__ + "static/media/Artboard7.47f4c9bc.png";